import * as React from "react";
import type { SVGProps } from "react";
const SvgLayerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="layer_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M897.877 255.275c80.64 24.576 80.64 138.752 0 163.285L549.291 524.672a128 128 0 0 1-74.582 0L126.165 418.56c-80.64-24.533-80.64-138.71 0-163.285l348.587-106.07a128 128 0 0 1 74.581 0l348.587 106.07zm-24.832 81.664L524.46 230.827a42.667 42.667 0 0 0-24.875 0l-348.63 106.112 348.587 106.069a42.667 42.667 0 0 0 24.875 0l348.63-106.07z"
    />
    <path
      fill="currentColor"
      d="M949.76 522.07a42.667 42.667 0 0 1-27.008 53.973L552.491 699.435a128 128 0 0 1-80.939 0L101.291 576.043a42.667 42.667 0 1 1 26.965-80.982l370.261 123.435a42.667 42.667 0 0 0 26.966 0l370.261-123.435a42.667 42.667 0 0 1 53.973 27.008z"
    />
    <path
      fill="currentColor"
      d="M949.76 698.581a42.667 42.667 0 0 1-27.008 53.974L552.491 875.989a128 128 0 0 1-80.982 0L101.248 752.555a42.667 42.667 0 1 1 27.008-80.939l370.261 123.435a42.667 42.667 0 0 0 26.966 0l370.261-123.435a42.667 42.667 0 0 1 53.973 27.008z"
    />
  </svg>
);
export default SvgLayerIcon;
